import ReceberPagamentoService from "@/services/ReceberPagamentoService";

export const receberPagamento = {
  namespaced: true,
  state: {
    receberPagamento: {},
  },
  actions: {
    getReceberPagamento({ commit }, payload) {
      return ReceberPagamentoService.GetReceberPagamento(payload).then(
        (receberPagamento) => {
          return Promise.resolve(receberPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postReceberPagamento({ commit }, payload) {
      return ReceberPagamentoService.PostReceberPagamento(payload).then(
        (receberPagamento) => {
          return Promise.resolve(receberPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putReceberPagamento({ commit }, payload) {
      return ReceberPagamentoService.PutReceberPagamento(payload).then(
        (receberPagamento) => {
          return Promise.resolve(receberPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteReceberPagamento({ commit }, payload) {
      return ReceberPagamentoService.DeleteReceberPagamento(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getReceberPagamentoOData({ commit }, payload) {
      return ReceberPagamentoService.GetReceberPagamentoOData(payload).then(
        (receberPagamento) => {
          return Promise.resolve(receberPagamento);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default receberPagamento;
